/* eslint-disable no-empty-pattern */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { Container } from "../../../globalstyled";
import AppLoader from "../../../components/loader";
import { useAccess } from "../../../hooks/useAccess";
import { NotificationWorkflow } from "./NotificationWorkflow";

interface DashboardProps {}

export const Notifications: React.FC<DashboardProps> = ({}) => {

  // Use the global hook for access permissions
  const { loading: accessLoading } = useAccess();

  if (accessLoading) {
    return <AppLoader isLoading={accessLoading} />;
  }

  const hostContainer = () => {
    return (
      <Container>
        <NotificationWorkflow />
      </Container>
    );
  };

  return hostContainer();
};
